import { BrowserRouter, Route, Routes } from "react-router"

import "./index.css";
import HomePage from "./pages/HomePage";
import NotFound from "./pages/NotFound";

export function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="" element={<HomePage />}/>
        <Route path="*" element={<NotFound />}/>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
